import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { AppLayout } from './UI/Layout/AppLayout';

interface ElectronicDonationPageProps {
  onBack: () => void;
  onNavigate?: (view: string) => void;
}

export const ElectronicDonationPage: React.FC<ElectronicDonationPageProps> = ({
  onBack,
  onNavigate,
}) => {
  return (
    <AppLayout
      title="Donazione Elettronica"
      showSyncButton={false}
      currentView="electronic-donation"
      onNavigate={onNavigate}
    >
      <Box sx={{ 
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100%',
        width: '100%',
        p: 3,
        gap: 3
      }}>
        {/* Titolo */}
        <Typography 
          variant="h4" 
          component="h1" 
          sx={{ 
            textAlign: 'center',
            fontWeight: 'bold',
            color: 'primary.main',
            mb: 2
          }}
        >
          Donazione Elettronica
        </Typography>

        {/* Sottotitolo */}
        <Typography 
          variant="h6" 
          component="h2" 
          sx={{ 
            textAlign: 'center',
            color: 'text.secondary',
            mb: 3,
            maxWidth: '600px'
          }}
        >
          Scansiona il QR code per effettuare una donazione online
        </Typography>

        {/* Container QR Code */}
        <Paper
          elevation={8}
          sx={{
            p: 4,
            borderRadius: 3,
            backgroundColor: 'white',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '300px',
            minHeight: '300px',
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
            border: '2px solid #f0f0f0'
          }}
        >
          {/* QR Code */}
          <Box
            component="img"
            src="/qr-code.png"
            alt="QR Code per donazione elettronica"
            sx={{
              width: '250px',
              height: '250px',
              objectFit: 'contain',
              borderRadius: 2,
              border: '1px solid #e0e0e0'
            }}
          />
        </Paper>

        {/* Istruzioni */}
        <Box sx={{ 
          textAlign: 'center',
          maxWidth: '500px',
          mt: 2
        }}>
          <Typography 
            variant="body1" 
            sx={{ 
              color: 'text.secondary',
              mb: 2,
              lineHeight: 1.6
            }}
          >
            Usa la fotocamera del tuo smartphone per scansionare il QR code e accedere alla pagina di donazione.
          </Typography>
          
          <Typography 
            variant="body2" 
            sx={{ 
              color: 'text.disabled',
              fontStyle: 'italic'
            }}
          >
            La donazione sarà gestita in modo sicuro tramite Tinaba
          </Typography>
        </Box>

        {/* Pulsante Indietro */}
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={onBack}
          sx={{
            mt: 3,
            px: 4,
            py: 1.5,
            borderRadius: 2,
            textTransform: 'none',
            fontSize: '1rem',
            fontWeight: '500'
          }}
        >
          Torna alla Dashboard
        </Button>
      </Box>
    </AppLayout>
  );
};
